module.exports = __webpack_public_path__ + "img/bul_device_union.a704db49.svg";